import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Firefox-ot használ a user.
 * @param ua - UserAgent.
 */
export default function isFF (ua: string): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return userAgentParser.isFF(ua)
}
